import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TenantUserList, TenantUser } from '../../_objects/user';
import { UserSchema } from '../../_offline/models/user.schema';
import { UserDbService } from '../database/user-db.service';
import { TenantUserContractService } from '../interfaces/tenant-user-contract.service';

@Injectable({
  providedIn: 'root'
})
export class TenantUserOfflineService implements TenantUserContractService {

  constructor(private userDbService: UserDbService) { }
  getUsers(): Observable<TenantUserList[]> {
    return this.userDbService.getAll()
      .pipe(
        map((values: UserSchema[]) => values.map(value => {
          const user = new TenantUserList();
          user.id = value.id;
          user.givenName = value.givenName;
          user.surname = value.surname;
          user.isActive = value.isActive !== null ? value.isActive : true;
          user.isSubscription = value.isSubscription !== null ? value.isSubscription : true;
          return user;
        }))
      );
  }

  getUser(id: string): Observable<TenantUser> {
    return this.userDbService.getOne(id)
      .pipe(
        map((value: UserSchema) => {
          const result = new TenantUser();
          result.id = value.id;
          result.givenName = value.givenName;
          result.surname = value.surname;
          return result;
        })
      );
  }
}
